import { Box, Typography, styled } from '@mui/material';
import { palette } from '../../theme/palette';

export const Root = styled(Box)`
  display: flex;
  gap: 5px;
  white-space: nowrap;
`;

export const Cell = styled(Box)``;

export const BaseTypography = styled(Typography)`
  font-size: 18px;
  font-style: normal;
  letter-spacing: 0.45px;
`;

export const Price = styled(BaseTypography)`
  color: ${palette.custom.darkGrey};
  font-weight: 700;
`;

export const Unit = styled(BaseTypography)`
  color: rgba(36, 36, 45, 0.6);
`;
